<template>
<div class="d-lg-flex flex-row-fluid">
    <div class="flex-column offcanvas-mobile w-300px w-xl-300px">
        <div class="card card-custom gutter-b">
            <Counter v-if="allConfig.closure.dscount==1" :enddate="allConfig.closure.date_end"></Counter>
            <SumaryPrimary :title="'Resumen de participación'" :subtitle="'Deportistas'" :percentage="tableSumary.length"></SumaryPrimary>
            <SumaryGender></SumaryGender>
            <SumaryStatus></SumaryStatus>
            <div class="mx-8 mb-6" v-if="allConfig.closure.bases !=null && allConfig.closure.bases != ''">
                <div class="btn btn-sm btn-info btn-block" @click="showBases"> <i class="el-icon-document"></i> Ver bases de la competencia</div>
            </div>
        </div>
    </div>

    <div class="flex-row-fluid ml-lg-6">
        <div class="card card-custom">
            <titleBack :title="allConfig.event.name" :subtitle="allConfig.sport.name" :back="'/athlete'"></titleBack>

            <div class="card-body">
                <div class="mb-8">
                    <div v-if="allConfig.closure.mstatus == 'O'" class="btn btn-sm btn-light-success font-weight-bolder" size="medium" @click="register">
                        <i class="el-icon-plus"></i> Registrar
                    </div>
                    <div class="btn btn-light-danger btn-sm mx-4" @click="pdfNominal">
                        <i class="el-icon-download"></i> Ficha Nominal
                    </div>
                    <div class="btn btn-secondary btn-sm" @click="pdfNC">
                        <i class="el-icon-download"></i> Nominal de competencia
                    </div>
                    <div v-if="allConfig.closure.mstatus == 'O'" class="btn btn-light-primary btn-sm float-right" @click="finishRegistration">
                        <i class="el-icon-s-promotion"></i> Finalizar inscripción
                    </div>
                </div>

                <div class="d-flex border-bottom pb-4">
                    <div class="flex-grow-1"></div>
                    <div class="flex-grow-1">
                        <el-input size="small" v-model="search" clearable placeholder="Buscar por participante"></el-input>
                    </div>
                </div>

                <!--el-table-->
                <el-table ref="multipleTable" :data="filteredData" highlight-current-row height="600" style="width: 100%">
                    <el-table-column fixed label="PARTICIPANTE" width="230px" :filters="[{ text: 'Aprobados', value: '1' }, { text: 'Anulados', value: '2' }, { text: 'Revisión', value: '3' }, { text: 'Subsanar', value: '4' }, { text: 'Borrador', value: '0' }]" :filter-method="filterTag" filter-placement="bottom-end">
                        <template #default="scope">
                            <div class="d-flex align-items-center">
                                <el-tooltip class="item" effect="dark" :content="status[scope.row.checkdoc].name" placement="top-start">
                                    <span :class="'mr-2 mb-1 label label-xl label-dot label-'+status[scope.row.checkdoc].class"></span>
                                </el-tooltip>

                                <div class="symbol symbol-40 symbol-light-success mr-3">
                                    <el-avatar shape="square" size="large" fit="contain" :src="scope.row.photo" :class="'border-'+status[scope.row.checkdoc].class"></el-avatar>
                                </div>
                                <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                                    <span>{{scope.row.firstname}} </span><br>
                                    <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="DOCUMENTO" width="120px">
                        <template #default="scope" width="100px">
                            <div style="line-height:1.25">
                                <span class="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{scope.row.docnumber}}</span>
                                <span class="text-secondary font-weight-bold d-block">{{scope.row.docName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="COD. UNIV" prop="studentcode" width="100px"></el-table-column>
                    <el-table-column label="SEXO" width="70px">
                        <template #default="scope">
                            <span v-if="scope.row.gender=='F'" class="label font-weight-bold label-lg label-light-danger label-inline">{{scope.row.gender}}</span>
                            <span v-else class="label font-weight-bold label-lg label-light-success label-inline">{{scope.row.gender}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="NACIMIENTO" prop="birthday" width="120px"></el-table-column>
                    <el-table-column label="OPCIONES" align="right" width="110px">
                        <template #default="scope">
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    Opciones<i class="el-icon-setting el-icon--right"></i>
                                </span>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item v-if="(scope.row.checkdoc==0 || scope.row.checkdoc==4)" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i> Editar</el-dropdown-item>
                                        <el-dropdown-item v-if="(scope.row.checkdoc==0 || scope.row.checkdoc==4) && allConfig.closure.mstatus=='O'" @click="handleDelete(scope.$index, tableSumary, scope.row)"><i class="el-icon-delete"></i> Eliminar</el-dropdown-item>
                                        <el-dropdown-item command="a" @click="pdfIndividual(scope.row.idacreditation)">
                                            <i class="el-icon-postcard"></i> Individual
                                        </el-dropdown-item>
                                        <el-dropdown-item command="b" @click="pdfDesagravio(scope.row.idacreditation)">
                                            <i class="el-icon-tickets"></i> Carta desagravio
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination layout="total" :total="filteredData.length"></el-pagination>
            </div>
        </div>
    </div>

    <!--start modal-->
    <el-dialog custom-class="mdnew" v-model="modalNew" title="Registrar deportista" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" width="60%" top="3vh" center>
        <el-steps :active="currentstep" finish-status="success" align-center>
            <el-step description="Datos personales"></el-step>
            <el-step description="Fotografia"></el-step>
            <el-step description="Datos académicos"></el-step>
            <el-step description="Competencia"></el-step>
            <el-step description="Documentación"></el-step>
        </el-steps>
        <div class="steps">
            <PesonalInformation v-if="currentstep==0"></PesonalInformation>
            <PhotoManager v-if="currentstep==1"></PhotoManager>
            <AcademicInformation v-if="currentstep==2"></AcademicInformation>
            <Pesas v-if="currentstep==3"></Pesas>
            <Documentation v-if="currentstep==4"></Documentation>
        </div>
    </el-dialog>

    <el-dialog v-model="modalEdit" custom-class="mdedit" :title="'Editar acreditación ' + title" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false" width="60%" top="3vh">
        <el-tabs v-if="modalEdit">
            <el-tab-pane label="Datos personales">
                <PesonalInformation :athletedata="athleteEdit"></PesonalInformation>
            </el-tab-pane>
            <el-tab-pane label="Fotografia">
                <PhotoManager :photoData="photoEdit"></PhotoManager>
            </el-tab-pane>
            <el-tab-pane label="Datos académicos">
                <AcademicInformation :academicdata="academEdit"></AcademicInformation>
            </el-tab-pane>
            <el-tab-pane label="Datos de competencia">
                <Pesas :competdata="competiEdit" :idacreditation="idacreditation"></Pesas>
            </el-tab-pane>
            <el-tab-pane label="Documentación">
                <Documentation :academicdata="academEdit"></Documentation>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>

    <el-dialog title="SISDEU" v-model="dialogFinish">
        <div v-html="responseFinish"></div>
    </el-dialog>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import dataJson from "@/data/common";
import code from "@/core/config/status.code";
import {
    STEP,
    MODAL_NEW,
    MODAL_EDIT
} from "@/store/step.module";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";
import {
    UBIGEO,
    ACREDITATION,
    LIST_ACREDITATION
} from "@/store/acreditation.module";

//services
import {
    acrService,
    acrError
} from '@/core/services/acr.service';

//components
import titleBack from "@/components/TitleBack";
import Counter from "@/components/Counter";
import PesonalInformation from "@/views/pages/steps/athletes/PersonalInformation";
import PhotoManager from "@/components/PhotoManager";
import AcademicInformation from "@/views/pages/steps/athletes/AcademicInformation";
import Documentation from "@/views/pages/steps/athletes/Documentation";
import Pesas from "@/components/forms/Pesas";

//resumenes
import SumaryPrimary from "@/components/SumaryPrimary";
import SumaryGender from "@/components/SumaryGender";
import SumaryStatus from "@/components/SumaryStatus";

export default {
    name: 'LevPesas',
    components: {
        titleBack,
        Counter,
        PesonalInformation,
        PhotoManager,
        AcademicInformation,
        Documentation,
        Pesas,
        SumaryPrimary,
        SumaryGender,
        SumaryStatus
    },
    data: () => ({
        title: '',
        search: '',
        athleteEdit: {},
        photoEdit: {},
        academEdit: {},
        competiEdit: [],
        allConfig: {
            event: {},
            sport: {},
            closure: {
                bases: null
            },
            report: {},
        },
        sanda: [],
        tableSumary: [],
        idacreditation: null,
        status: dataJson.statusacrd,
        dialogFinish: false,
        responseFinish: null
    }),
    computed: {
        ...mapGetters(['currentstep', 'currentAcreditation', 'modalNew', 'modalEdit', 'currentDataListAcrd']),
        filteredData: function () {
            this.tableSumary = this.currentDataListAcrd;
            return this.tableSumary.filter(data => !this.search || data.firstname.toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods: {
        filterTag(value, row) {
            return row.checkdoc === value;
        },
        async configInitial() {
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.configSport({
                    sport: 'levpesas',
                    data: this.currentAcreditation
                });
                this.allConfig = res.data;
                this.$store.dispatch(UBIGEO, res.data.ubigeo);
                this.$store.dispatch(LIST_ACREDITATION, {
                        sport: 'levpesas',
                        data: this.currentAcreditation
                    })
                    .then(() => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    })
                    .catch((err) => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    });
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode, 'athlete');
                        }
                    });
                }
            }
        },
        showBases() {
            window.open(this.allConfig.closure.bases, '_blank');
        },
        async register() {
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.status(this.currentAcreditation);
                this.$store.dispatch(ACREDITATION, res.data);
                this.$store.dispatch(STEP, 0).then(() => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    this.$store.dispatch(MODAL_NEW, true);
                });
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async handleEdit(a) {
            try {
                this.title = 'para ' + a.firstname;
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                this.idacreditation = a.idacreditation;
                const res = await acrService.edit(a.idacreditation);
                this.athleteEdit = res.data.athlete;
                this.photoEdit = res.data.photo;
                this.academEdit = res.data.acrd;
                this.competiEdit = res.data.test;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$store.dispatch(MODAL_EDIT, true);

            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async handleDelete(index, rows, a) {
            try {
                const result = await this.$confirm('Esto eliminará permanentemente el registro. ¿Continuar?', 'Eliminar participación de ' + a.firstname, {
                    confirmButtonText: 'SI',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                });
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.delete(window.btoa(a.idacreditation));
                rows.splice(index, 1);
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$message({
                    type: 'success',
                    message: 'Acreditación de ' + a.firstname + ' eliminada correctamente.'
                });
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        pdfNominal() {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/nominal?a=${this.allConfig.report.a}&b=${this.allConfig.report.b}&c=${this.allConfig.report.c}&d=${this.allConfig.report.d}`, '_blank');
        },
        pdfNC() {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/nominal/levpesas?a=${this.allConfig.report.a}&b=${this.allConfig.report.b}&c=${this.allConfig.report.c}`, '_blank');
        },
        pdfIndividual(a) {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/ficha-individual/${window.btoa(a)}`, '_blank');
        },
        pdfDesagravio(a) {
            window.open(process.env.VUE_APP_URL_BACKEND + `pdf/carta-desagravio/${window.btoa(a)}`, '_blank');
        },
        async finishRegistration() {
            try {
                const result = await this.$confirm(dataJson.textFinalice, dataJson.titleFinalice, {
                    confirmButtonText: 'SI',
                    cancelButtonText: 'Cancelar',
                });
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await acrService.finish(this.currentAcreditation);
                this.responseFinish = res.data.message;
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$store.dispatch(LIST_ACREDITATION, {
                        sport: 'levpesas',
                        data: this.currentAcreditation
                    })
                    .then(() => {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                        this.dialogFinish = true;
                    })
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        }
    },
    created() {
        if (this.currentAcreditation.idevent == undefined || this.currentAcreditation.idsport == undefined)
            return this.$router.push({
                name: "athlete"
            });
        this.configInitial();
    }
}
</script>
